import {
    cilBank,
    cilTransfer,
    cilBrowser,
    cilWallet,
    cilAvTimer,
    cilScreenDesktop,
    cilShieldAlt,
    cilMoney,
    cilCash,
    cilChartLine,
    cilClock,
    cilCog,
    cilCreditCard,
    cilDollar,
    cilRouter,
    cilSend,
    cilSettings,
    cilSpreadsheet,
    cilStream,
    cilAddressBook,
    cilUser,
    cilPuzzle,
    cilList,
} from '@coreui/icons'
export default [
    {
        component: 'CNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
    },
    {
        component: 'CNavTitle',
        name: 'Master Data',
    },
    {
        component: 'CNavItem',
        name: 'Merchant',
        to: '/merchant',
        icon: cilBrowser,
    },
    {
        component: 'CNavItem',
        name: 'Merchant Setup',
        to: '/merchant_setup',
        icon: cilCog,
    },
    {
        component: 'CNavItem',
        name: 'Merchant Readiness',
        to: '/merchant_readiness',
        icon: cilAvTimer,
    },
    {
        component: 'CNavItem',
        name: 'Bank',
        to: '/bank',
        icon: cilBank,
    },

    {
        component: 'CNavTitle',
        name: 'Agent Management',
    },
    {
        component: 'CNavItem',
        name: 'Agent',
        to: '/agent',
        icon: cilScreenDesktop,
    },
    {
        component: 'CNavItem',
        name: 'Agent Bank Account',
        to: '/agent_bank_account',
        icon: cilWallet,
    },
    {
        component: 'CNavTitle',
        name: 'Transaction',
    },
    {
        component: 'CNavItem',
        name: 'Transaction',
        to: '/transaction',
        icon: cilTransfer,
    },
    {
        component: 'CNavItem',
        name: 'Inquiries',
        to: '/inquiries',
        icon: cilAvTimer,
    },
    {
        component: 'CNavItem',
        name: 'Withdrawal',
        to: '/withdrawal',
        icon: cilMoney,
    },
    {
        component: 'CNavTitle',
        name: 'Reporting',
    },
    {
        component: 'CNavItem',
        name: 'Inquiry Report',
        to: '/reporting/inquiries',
        icon: cilAvTimer,
    },
    {
        component: 'CNavItem',
        name: 'Withdrawal Report',
        to: '/reporting/withdrawals',
        icon: cilMoney,
    },
    {
        component: 'CNavItem',
        name: 'Crypto Deposit Report',
        to: '/reporting/crypto_deposits',
        icon: cilWallet,
    },
    {
        component: 'CNavTitle',
        name: 'Crypto',
    },
    {
        name: 'Operations',
        icon: cilCreditCard,
        items: [
            {
                component: 'CNavItem',
                name: 'Crypto Payments',
                to: '/crypto_payment',
                icon: cilCreditCard,
            },
            {
                component: 'CNavItem',
                name: 'Crypto Withdrawals',
                to: '/crypto_withdrawal',
                icon: cilSend,
            },
            {
                component: 'CNavItem',
                name: 'Crypto Transfers',
                to: '/crypto_transfer',
                icon: cilStream,
            },
        ],
    },
    {
        name: 'Finances',
        icon: cilDollar,
        items: [
            {
                component: 'CNavItem',
                name: 'Crypto Statements',
                to: '/crypto_merchant_balance',
                icon: cilSpreadsheet,
            },
            {
                component: 'CNavItem',
                name: 'Wallet Funds Overview',
                to: '/crypto_wallet_funds',
                icon: cilWallet,
            },
            {
                component: 'CNavItem',
                name: 'Crypto Rates',
                to: '/crypto_rates',
                icon: cilChartLine,
            },
        ],
    },
    {
        name: 'Setup',
        icon: cilCog,
        items: [
            {
                component: 'CNavItem',
                name: 'Crypto Wallets',
                to: '/crypto_wallet',
                icon: cilWallet,
            },
            {
                component: 'CNavItem',
                name: 'Crypto Providers',
                to: '/crypto_provider',
                icon: cilRouter,
            },
            {
                component: 'CNavItem',
                name: 'Crypto Settings',
                to: '/crypto_settings',
                icon: cilSettings,
            },
        ],
    },
    {
        name: 'Monitoring',
        icon: cilClock,
        items: [
            {
                component: 'CNavItem',
                name: 'Crypto Health',
                to: '/crypto_health',
                icon: cilAvTimer,
            },
        ],
    },
    {
        component: 'CNavTitle',
        name: 'Payment Gateway',
    },
    {
      component: 'CNavItem',
      name: 'Health',
      to: '/payment_gateway/health',
      icon: cilAvTimer,
    },
    {
        component: 'CNavItem',
        name: 'Provider Rates',
        to: '/payment_gateway/rates',
        icon: cilChartLine,
    },
    {
        component: 'CNavItem',
        name: 'Profiles',
        to: '/payment_gateway/profiles',
        icon: cilPuzzle,
    },
    {
        component: 'CNavItem',
        name: 'Channels',
        to: '/payment_gateway/channels',
        icon: cilBrowser,
    },
    {
        component: 'CNavItem',
        name: 'Deposits',
        to: '/payment_gateway/deposits',
        icon: cilWallet,
    },
    {
        component: 'CNavItem',
        name: 'Withdrawals',
        to: '/payment_gateway/withdrawals',
        icon: cilTransfer,
    },
    {
        component: 'CNavTitle',
        name: 'License',
    },
    {
        component: 'CNavItem',
        name: 'License',
        to: '/license',
        icon: cilShieldAlt,
    },
    {
        component: 'CNavTitle',
        name: 'User',
    },
    {
        component: 'CNavItem',
        name: 'User',
        to: '/user',
        icon: cilUser,
    },
    {
        component: 'CNavItem',
        name: 'User Api',
        to: '/user_api',
        icon: cilAddressBook,
    },
    {
        component: 'CNavItem',
        name: 'User API Merchant',
        to: '/user_api_merchant',
        icon: cilShieldAlt,
    },
    {
        component: 'CNavTitle',
        name: 'Log',
    },
    {
        component: 'CNavItem',
        name: 'Callback Log',
        to: '/callback_log',
        icon: 'cilList',
    },
    {
        component: 'CNavItem',
        name: 'Withdrawal Callback Log',
        to: '/withdrawal_callback_log',
        icon: 'cilList',
    },
    {
        component: 'CNavItem',
        name: 'Crypto Callback Log',
        to: '/crypto_deposit_callback_log',
        icon: 'cilList',
    },
    {
        component: 'CNavItem',
        name: 'Crypto Withdrawal Callback Log',
        to: '/crypto_withdrawal_callback_log',
        icon: 'cilList',
    },
    {
        component: 'CNavItem',
        name: 'Payment Gateway Callback Log',
        to: '/payment_gateway_callback_log',
        icon: cilList,
    },
]
